import { useEffect, useRef } from 'react';

const useOutsideClick = (callback: () => void, additionalConditions: boolean, options?: any) => {
    const mergedAdditionalConditions = additionalConditions ?? true;
    const insideRef = useRef<HTMLDivElement>(null);
    const outsideRef = useRef<HTMLDivElement>(null);

    const onOutsideClick = ({ target }: { target: any }) => {
        if (mergedAdditionalConditions) {
            if (
                outsideRef?.current &&
                outsideRef?.current.contains(target) &&
                insideRef?.current &&
                !insideRef?.current.contains(target)
            ) {
                return callback();
            }
            if (
                !outsideRef?.current &&
                insideRef?.current &&
                !insideRef?.current.contains(target)
            ) {
                return callback();
            }
        }
        return null;
    };
    useEffect(() => {
        document.addEventListener('click', onOutsideClick, options);
        return () => {
            document.removeEventListener('click', onOutsideClick, options);
        };
    });
    return [insideRef, outsideRef];
};

export default useOutsideClick;
